import {
  ID__ATS_TYPE__NONE
} from '../../Definition';
import {
  Obj
} from '../../Object.lib';
import {
  Str
} from '../../String.lib';
import getAtsContextMapped from './getAtsContextMapped.fun';

/**
 * @function
 * @description Returns a value from the atsContext of an entity by atsTypeId and property name.
 * @param {object} [entity={}] - The entity object to access the atsContext from.
 * @param {number} [atsTypeId=ID__ATS_TYPE__NONE] - The ATS type Id to access the property from.
 * @param {string} [property=''] - The property name to access from the atsContext.
 * @returns {string} The value of the requested property, trimmed.
 * 
 * @example structure
 * Employer.atsContext = {
 *   [ID__ATS_TYPE__ASHBY_API]: {
 *     sourceId: 'ashbySourceId',
 *     userId: 'ashbyUserId',
 *     apiKey: 'ashbyApiKey'
 *   },
 *   [ID__ATS_TYPE__GREENHOUSE_API]: {
 *     sourceId: 'greenhouseSourceId',
 *     userId: 'greenhouseUserId',
 *     apiKey: 'greenhouseApiKey'
 *   }
 * }
 */
export default function getAtsContextProperty({
  collection = null,
  entity = {},
  atsTypeId = ID__ATS_TYPE__NONE,
  property = ''
}) {
  return Str(
    Obj(
      getAtsContextMapped({
        collection,
        entity,
        atsTypeId
      })[atsTypeId]
    )[property]
  );
}
